var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_687_39470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5143 2.45268L13.5471 6.4855L5.62796 14.4046C5.40734 14.6252 5.13295 14.7844 4.83194 14.8665L0.755539 15.9783C0.309408 16.1 -0.0999539 15.6906 0.0217183 15.2445L1.13346 11.1681C1.21556 10.867 1.37479 10.5927 1.59542 10.372L9.5143 2.45268ZM15.0429 0.720119L15.1648 0.835168L15.2799 0.957062C16.277 2.0768 16.2386 3.79393 15.1648 4.86772L14.3918 5.64005L10.3589 1.60803L11.1323 0.835168C12.2061 -0.238619 13.9232 -0.276969 15.0429 0.720119Z",
    fill: "#B9BBBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_687_39470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic-edit.3e7b3400eff99ea69db7362938ac731e.svg";
export { ForwardRef as ReactComponent };